module.exports = __webpack_public_path__ + "static/media/18.8b30e5a6.jpg";